const REMEMBER_ME_KEY = '354f1090-b310-41ba-9a30-5d4f678e80f6';
const TOKEN = 'a88ad161-5f09-4a5a-a5a3-6fef87a9e3a8';
const EXPIRE_DATE = '44e94913-217a-42d1-9d6a-b1df3a3da1a6';
const ROLE = '19e2f689-52c2-48c6-a919-d6763d26f7b5';
const USER_ID = '14bed01e-4f7f-4bcc-ad12-55d8d27ad9e0';
const USER_ID_KEY1 = '48c6';
const USER_ID_KEY2 = '354f1090';

export const getRememberMe = () => {
	const value = localStorage.getItem(REMEMBER_ME_KEY);
	if (value !== null) {
		return value;
	} else {
		return 2;
	}
};

export const setRememberMe = (key: string) => {
	localStorage.setItem(REMEMBER_ME_KEY, key);
};

export const getAccessToken = () => {
	setExpireTime();
	return localStorage.getItem(TOKEN);
};

export const setAccessToken = (token: string) => {
	localStorage.setItem(TOKEN, token);
};

export const getUserRole = (): string => {
	const value = localStorage.getItem(ROLE);
	if (value) {
		return value;
	} else {
		return '0';
	}
};

export const setUserRole = (role: string) => {
	localStorage.setItem(ROLE, role);
};

export const getUserId = () => {
	const value = localStorage.getItem(USER_ID);
	if (value) {
		const id = value.replace(USER_ID_KEY1, '').replace(USER_ID_KEY2, '');
		return id;
	} else {
		return value;
	}
};

export const setUserId = (id: string) => {
	localStorage.setItem(USER_ID, `${USER_ID_KEY1}${id}${USER_ID_KEY2}`);
};

export const getExpireTime = () => {
	return localStorage.getItem(EXPIRE_DATE);
};

export const setExpireTime = () => {
	const currentDate = new Date();
	const expDate = new Date(currentDate.getTime() + 1000 * 60 * 60 * 48);
	localStorage.setItem(EXPIRE_DATE, `${expDate.getTime()}`);
};

export const signOut = () => {
	localStorage.clear();
	window.location.reload();
};
